import { IApiEpOrganization } from "@smp/api";
import { UiAvatar, UiBox, UiMenuItem, UiTypography } from "@smp/ui";
import { forwardRef, ReactNode } from "react";

import { useStyles } from "./menu_item.css";

export const MenuItem = forwardRef<
  HTMLLIElement,
  {
    disabled?: boolean;
    label: ReactNode;
    icon: ReactNode;
    onClick: (organizationId: IApiEpOrganization["id"] | null) => void;
    organizationId: IApiEpOrganization["id"] | null;
    selected: boolean;
  }
>(({ disabled, icon, label, onClick, organizationId, selected }, ref) => {
  const classes = useStyles();

  const handleClick = () => {
    onClick(organizationId);
  };

  return (
    <UiMenuItem
      disabled={disabled}
      onClick={handleClick}
      ref={ref}
      selected={selected}
    >
      <UiBox alignItems="center" display="flex" flexDirection="row">
        <UiBox mr={1}>
          <UiAvatar className={classes.avatar}>{icon}</UiAvatar>
        </UiBox>
        <UiBox>
          <UiTypography
            align="left"
            className={classes.label}
            noWrap
            variant="subtitle1"
          >
            {label}
          </UiTypography>
        </UiBox>
      </UiBox>
    </UiMenuItem>
  );
});
